export default __webpack_public_path__ + "static/media/cust3.55db3da0.jpg";